import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e7c40c3e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e7c40c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c40c3e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsBreadcrumbs: require('/var/web/bet777.es/components/elements/breadcrumbs.vue').default,ElementsSeguroCombinadaTooltip: require('/var/web/bet777.es/components/elements/seguro-combinada-tooltip.vue').default,EventsWidget: require('/var/web/bet777.es/components/events/widget.vue').default,OutrightsLinks: require('/var/web/bet777.es/components/outrights-links.vue').default})
